import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  currentStatementDate: {
    display: 'flex'
  },
  currentStatementDays: {
    backgroundColor: props => palette[props.isPaymentClose].light,
    borderRadius: '2px',
    marginLeft: '20px',
    padding: '10px 18px',
    '& .MuiTypography-root': {
      color: props => palette[props.isPaymentClose].dark
    }
  },
  currentStatementTitle: {
    alignItems: 'center',
    backgroundColor: palette.shades[100],
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '32px',
    padding: '18px 32px'
  }
});
export default useStyles;